import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface PrefacturarButtonProps {
  /** Función que se ejecuta al hacer click */
  onClick?: () => void;
  /** Si true, muestra el botón deshabilitado */
  disabled?: boolean;
}

/**
 * Componente para el botón de prefacturar
 * Maneja la acción de prefacturar storages elegibles usando filtros
 */
export const PrefacturarButton = ({ onClick, disabled = false }: PrefacturarButtonProps) => {
  const { t } = useTranslation('eligibleStorageModule');

  return (
    <div className="flex justify-end absolute right-4 top-2">
      <Button variant="primary" onClick={onClick} disabled={disabled} data-testid="prefacturar-button">
        {t('buttons.prefacturar', 'Prefacturar')}
      </Button>
    </div>
  );
};
